import { Font, StyleSheet } from "@react-pdf/renderer";

Font.register({
  family: "NotoEmoji",
  src: "/NotoEmoji-Regular.ttf",
});

export const pdfStyle = StyleSheet.create({
  page: {
    padding: "40px 20px",
  },
  flex: {
    display: "flex",
    flexDirection: "row",
  },
  tableRow: {
    flexDirection: "row",
  },
  cell: {
    width: "33.33%",
  },

  biddingRow: {
    display: "flex",
    flexDirection: "row",
    fontSize: 10,
  },
  biddingCell: {
    width: "25%",
    fontFamily: "NotoEmoji",
    borderStyle: "solid",
    borderColor: "#cccccc",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 2,
    minHeight: 16,
  },
});
